import { LoraDevice } from '@enmon/commons/lib/tools';
import { stringify } from 'qs';
import { BaseApiClient } from './baseApiClient';

export class LoraDevicesApiClient extends BaseApiClient<LoraDevice> {
  constructor() {
    super('lora-devices');
  }

  async findByDevEui(devEui: LoraDevice['dev_eui']): Promise<LoraDevice[]> {
    return await this.http.get<LoraDevice[]>('', {
      params: { filters: { dev_eui: { $eqi: devEui } } },
      paramsSerializer: params => stringify(params, { allowDots: false }),
    });
  }
}
